































import Vue from 'vue';
import {
  Component,
} from 'vue-property-decorator';

enum NotificationTypes {
  ERROR = 'error',
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
}

interface Notification {
  innerText: string;
  lifetime: number;
  hidden: boolean;
  dismissable: boolean;
  type: NotificationTypes;
}

@Component({
  components: {
  },
})
export default class NotificationsSnackbar extends Vue {
  notifications: Array<Notification> = [
    {
      innerText: '',
      lifetime: 0,
      hidden: true,
      dismissable: true,
      type: NotificationTypes.INFO,
    },
  ]

  NotificationTypes = NotificationTypes;

  beforeMount() {
    this.$bus.$on('notification', this.addNotification);
  }

  /**
   * lifetime = 0 означает «выбери сам по типу». Текст ошибки бывает длинным
   * (сообщение сервиса, а не короткое «готово»), и 10 секунд на него мало:
   * пользователь не успевает прочитать, а поддержке потом нечего процитировать.
   */
  addNotification(text: string, type: NotificationTypes = NotificationTypes.INFO, lifetime = 0, dismissable = true) {
    const ttl = lifetime || (type === NotificationTypes.ERROR ? 60 : 10);
    const notification = {
      innerText: text,
      type,
      lifetime: ttl,
      dismissable,
      hidden: false,
    };
    this.notifications.push(notification);
    setTimeout(() => {
      notification.hidden = true;
    }, ttl * 1000);
  }

  dismiss(notification: Notification) {
    notification.hidden = true;
  }
}
